module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAYAAAC5Sw6hAAAA/ElEQVQoU53RMUpDQRDG8f/3LFIIKtY5Qi4gKNrpDUJKn2KnYDxAJlYWGkXbGEvJDbRTFCxsc4TUomCRgHkj+0LQ6MtDs93uzPx2dkfEdoJ7lemXMxNVhLuI7RooT2dFVa5qp0qLd88LvL/cgK/9C5MatOwg1AyhsHaO5vnoPeJe+iPWpmUVJB+Hwm7biiQ84V7MxaR7ZhfXudjrj/K+OhqdbFmJhAfwhUxM6jDHCmf2+j3+GwrRzcNVNLjFKYxhUpeIJZrW/XlJNpQ+s15mkIRpDnOkN8Qyl9bJ6nQylHZW34ekgegTaYOm3U36u3woVMV2TKRnmrV23gA+AcBFQkcidBGvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/icon-enter.png
// module id = DMSO
// module chunks = 3